import { ActionReducerMap } from "@ngrx/store";

import * as AppReducer from "src/app/ngrx/app.reducer";
import * as AuthReducer from "src/app/modules/auth/ngrx/auth.reducer";
import * as ESimReducer from "src/app/modules/esim/ngrx/esim.reducer";
import * as APIReducer from "src/app/api/ngrx/api.reducer";

export interface AppState {
  api: APIReducer.APIState;
  app: AppReducer.AppState;
  auth: AuthReducer.AuthState;
  esim: ESimReducer.ESimState;
}

export const reducers: ActionReducerMap<AppState> = {
  api: APIReducer.APIReducer,
  app: AppReducer.AppReducer,
  auth: AuthReducer.AuthReducer,
  esim: ESimReducer.ESimReducer,
};
